module.exports = __webpack_public_path__ + "img/arrow-secondary.7b3671ca.svg";